// /src/data/books/BitcoinGrowth/summary.js
const BITCOIN_GROWTH_SUMMARY = {
  "title": "Así crece el Bitcoin — Resumen",
  "sections": [
    {
      "heading": "Visión general",
      "text": "Relato histórico-técnico del surgimiento de Bitcoin: contexto post-2008, publicación del whitepaper, bloque génesis, arranque de la red y primeras referencias de precio. Explica cómo la inmutabilidad, la descentralización y el consenso sustituyen a los intermediarios tradicionales y por qué esto cambia la conversación sobre confianza y valor."
    },
    {
      "heading": "Puntos clave",
      "text": "- Del colapso financiero de 2008 a un efectivo electrónico P2P.\n- Bloque génesis con prueba de tiempo y crítica al sistema bancario.\n- Minería inicial y recompensa de 50 BTC por bloque.\n- Primeras cotizaciones (New Liberty Standard) y transacciones que fijan hitos de precio.\n- Bitcoin como fenómeno técnico, económico y cultural (más allá de la especulación)."
    },
    {
      "heading": "¿Para quién es este libro?",
      "text": "Estudiantes y autodidactas de blockchain/finanzas; emprendedores Web3; responsables de innovación; y cualquier lector que busque comprender Bitcoin sin tecnicismos excesivos pero con rigor conceptual."
    },
    {
      "heading": "Objetivos de aprendizaje",
      "text": "- Entender el problema de confianza/ emisión que Bitcoin aborda.\n- Describir cómo la cadena de bloques garantiza verificación abierta e inmutabilidad.\n- Reconocer hitos tempranos: whitepaper, bloque génesis, minería y primeros precios.\n- Identificar los incentivos y la filosofía que sostienen a Bitcoin."
    },
   
    {
      "heading": "Términos esenciales",
      "text": "Bloque génesis: primer bloque de la cadena.\nInmutabilidad: no se puede alterar el historial validado sin rehacer la cadena.\nMinería: validación y agregado de bloques con recompensa en BTC.\nSatoshi: unidad mínima de BTC (0.00000001 BTC).\nP2P: arquitectura entre pares sin servidor central."
    }
  ],
  "image": {
    "src": "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/ChatGPT%20Image%2012%20nov%202025%2C%2002_45_00.png",
    "alt": "Portada del libro Así crece el Bitcoin",
    "caption": "Resumen del libro: de la crisis de 2008 al nacimiento de un sistema de dinero abierto y descentralizado."
  }
};

export default BITCOIN_GROWTH_SUMMARY;
